// frontend/entrypoints/StickySidebar.js
/**
* StickySidebar.js
* A short JavaScript code that allows you to quickly and easily implement a Sticky Sidebar,
* if the browser's viewport is too short, sidebar's contents will scroll in the direction
* the user scrolls and sticks to either top or bottom of the screen when there's no more content.
* And everything with the use of pure JavaScript,
* thanks to which you we'll save redundant code and gain efficiency.
* -- Krzysztof Antosik
*
*
* @license The MIT License, https://github.com/Krzysztof-Antosik/Two-direction-Sticky-Sidebar/blob/main/LICENSE
* @version 1.7.1
* @author  Krzysztof Antosik, https://github.com/Krzysztof-Antosik/
* @contributors Krzysztof-Antosik, vadim-on-github
* @changelog https://github.com/Krzysztof-Antosik/Two-Direction-Sticky-Sidebar/blob/main/CHANGELOG.md
* @link    https://github.com/Krzysztof-Antosik/Two-direction-Sticky-Sidebar/
*
*
*/
var StickySidebar_default = () => {
	const stickyElement = document.querySelector(`[data-sticky="true"]`);
	if (stickyElement) {
		const startPosition = stickyElement.getBoundingClientRect().top;
		var endScroll = window.innerHeight - stickyElement.offsetHeight - 500, currPos = window.scrollY, screenHeight = window.innerHeight, stickyElementHeight = stickyElement.offsetHeight, topGap = 0, bottomGap = 0, width = window.innerWidth, mobileWidth = 0;
		const readCssTopGap = () => {
			const inlineTop = stickyElement.style.top;
			stickyElement.style.top = "";
			const gap = parseFloat(getComputedStyle(stickyElement).top) || 0;
			stickyElement.style.top = inlineTop;
			return gap;
		};
		if (!stickyElement.hasAttribute(`data-top-gap`)) topGap = readCssTopGap();
		setTimeout(() => {
			if (stickyElement.hasAttribute(`data-top-gap`)) {
				const dataTopGap = stickyElement.dataset.topGap;
				topGap = String(dataTopGap) == "auto" ? startPosition : parseInt(dataTopGap);
			}
			if (stickyElement.hasAttribute(`data-bottom-gap`)) bottomGap = parseInt(stickyElement.dataset.bottomGap);
			if (stickyElement.hasAttribute(`data-mobile-width`)) mobileWidth = parseInt(stickyElement.dataset.mobileWidth);
		}, 100);
		function offStickyOnMobile() {
			if (width > mobileWidth) {
				stickyElement.style.position = `sticky`;
				stickyElement.style.top = topGap + `px`;
				stickyElement.style.height = "fit-content";
			} else stickyElement.removeAttribute(`style`);
		}
		offStickyOnMobile();
		function positionStickySidebar() {
			endScroll = window.innerHeight - stickyElement.offsetHeight - bottomGap;
			let stickyElementTop = parseInt(stickyElement.style.top.replace(`px`, ``));
			if (stickyElementHeight + topGap + bottomGap > screenHeight) {
				if (window.scrollY < currPos) {
					if (stickyElementTop < topGap) stickyElement.style.top = stickyElementTop + currPos - window.scrollY + `px`;
					else if (stickyElementTop >= topGap && stickyElementTop != topGap) stickyElement.style.top = topGap + `px`;
				} else if (stickyElementTop > endScroll) stickyElement.style.top = stickyElementTop + currPos - window.scrollY + `px`;
				else if (stickyElementTop < endScroll && stickyElementTop != endScroll) stickyElement.style.top = endScroll + `px`;
			} else stickyElement.style.top = topGap + `px`;
			currPos = window.scrollY;
		}
		function updateSticky() {
			screenHeight = window.innerHeight;
			stickyElementHeight = stickyElement.offsetHeight;
			positionStickySidebar();
		}
		function initSticky() {
			width = window.innerWidth;
			currPos = window.scrollY;
			if (!stickyElement.hasAttribute(`data-top-gap`)) topGap = readCssTopGap();
			updateSticky();
			offStickyOnMobile();
		}
		setTimeout(() => {
			window.addEventListener(`resize`, () => {
				initSticky();
			});
			document.addEventListener(`scroll`, updateSticky, {
				capture: true,
				passive: true
			});
			initSticky();
		}, 300);
	}
};
export { StickySidebar_default as default };
